import { base64Prefix } from 'shared/constants';

import type { ErrorCode, FileError } from 'react-dropzone-latest';

import { additionalErrorCodes, dropzoneMessageForErrorCodes } from './constants';

export const getDropzoneErrorMessage = (code: ErrorCode) => translate(dropzoneMessageForErrorCodes[code]);

export const formatFileSize = (size: number) => {
  const i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
  const s = size / Math.pow(1024, i);
  return `${s.toFixed(2)} ${['B', 'kB', 'MB', 'GB', 'TB'][i]}`;
};

export const arrayBufferToBase64 = (buffer: ArrayBuffer) => {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
};

export const getFileContentAsBase64String = (file: File): Promise<string> => {
  const reader = new FileReader();

  return new Promise((resolve, reject) => {
    reader.onabort = () => {
      const error: FileError = {
        code: additionalErrorCodes.fileReadingAborted,
        message: 'File reading was aborted',
      };
      reject(error);
    };

    reader.onerror = () => {
      const error: FileError = {
        code: additionalErrorCodes.fileReadingFailed,
        message: 'File reading was failed',
      };
      reject(error);
    };

    reader.onload = (evt) => {
      const stringOrBuf = evt.target.result;

      const base64String = typeof stringOrBuf === 'string' ? stringOrBuf : arrayBufferToBase64(stringOrBuf);

      resolve(base64String.replace(base64Prefix, ''));
    };

    reader.readAsDataURL(file);
  });
};
